import { WAIT_FOR_ACTION } from 'redux-wait-for-action';
import * as actionTypes from './actionTypes';
export const restoreSso = (restoreSsoAt, fullPath)=>({
        type: actionTypes.RESTORE_SSO,
        [WAIT_FOR_ACTION]: actionTypes.RESTORE_SSO_SUCCESS,
        payload: {
            restoreSsoAt,
            fullPath
        }
    });
export const patientSetup = (createPatientProfile, updateInformations, updateAccountSettings)=>({
        type: actionTypes.PATIENT_SETUP,
        payload: {
            createPatientProfile,
            updateInformations,
            updateAccountSettings
        }
    });
export const patientSetupSuccess = ()=>({
        type: actionTypes.PATIENT_SETUP_SUCCESS,
        payload: {}
    });
export const patientSetupError = (error)=>({
        type: actionTypes.PATIENT_SETUP_ERROR,
        error
    });
